import React, { Component } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import { history } from '../../_helpers'
import Loading from '../Shared/Loading'
import { appUsersService } from '../../_services/AppUsers.service'
import accessTypes from '../../_constants/accessTypes'
import GenderSelect from '../Shared/GenderSelect'
import RoleSelect from '../Shared/RoleSelect'
import ErrorPopUp from '../Shared/ErrorPopUp'
import UnionSelectForAdmin from '../Shared/UnionSelectForAdmin'

import FormikCheckbox from '../Shared/FormikCheckbox'
import Checkbox from '../Shared/Checkbox'
import { Formik, Field, ErrorMessage, getIn } from 'formik'
import * as Yup from 'yup'
import debounce from 'debounce'
import NumberFormat from 'react-number-format'

import PasswordHelper from '../Shared/PasswordHelper'
import owasp from 'owasp-password-strength-test'

owasp.config({
  allowPassphrases: false,
  minLength: 8
})

class NewAppUser extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: false,
      model: {},
      key: 'info',
      passwordValue: '',
      passwordTestStatus: {
        minLengthTestPasses: false
        // maxLengthTestPasses: true,
        // repeatedCharactersTestPasses: true,
        // containsUppercaseLetterTestPasses: false,
        // containsLowercaseLetterTestPasses: false,
        // containsNumberTestPasses: false,
        // containsSpecialCharacterTestPasses: false
      }
    }
  }

  onPasswordChange = (e, setFieldValue) => {
    const { failedTests: failed, passedTests: passed } = owasp.test(
      e.target.value
    )
    const testDefinitelyPassed = testIndex => {
      // console.log(!failed.includes(testIndex) && passed.includes(testIndex));
      return !failed.includes(testIndex) && passed.includes(testIndex)
    }

    // const { setFieldTouched, setFieldValue } = this.props;
    setFieldValue('password', e.target.value)
    // setFieldTouched("password");

    this.setState({
      passwordValue: e.target.value,
      passwordTestStatus: {
        minLengthTestPasses: testDefinitelyPassed(0)
        // maxLengthTestPasses: testDefinitelyPassed(1),
        // repeatedCharactersTestPasses: testDefinitelyPassed(2),
        // containsLowercaseLetterTestPasses: testDefinitelyPassed(3),
        // containsUppercaseLetterTestPasses: testDefinitelyPassed(4),
        // containsNumberTestPasses: testDefinitelyPassed(5),
        // containsSpecialCharacterTestPasses: testDefinitelyPassed(6)
      }
    })
  }

  handleSubmit = values => {
    this.setState({ loading: true })
    // console.log(JSON.stringify(values));

    appUsersService
      .add(JSON.stringify(values))
      .then(res => {
        this.setState({ loading: false })
        toastr.success(
          'ثبت کاربر  جدید',
          'کاربر  جدید  "' +
            values.firstName +
            ' ' +
            values.lastName +
            '" با موفقیت ثبت شد'
        )
        history.push('/admin/user')
      })
      .catch(error => {
        // console.log(error);
        // toastr.warning("خطا", error.message)
        this.handleError(error)
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    // toastr.warning('مشکلی پیش آمد', error);
  }

  checkEmail = async value => {
    await appUsersService.checkEmail(value).then(res => {
      // console.log(res.data);
      return res.data
    })
  }

  debouncedCheckEmail = debounce(this.checkEmail, 300) // 300ms debounce

  handleToggle = (value, items) => () => {
    // console.log("He");

    const currentIndex = items.indexOf(value)
    const newItems = [...items]

    if (currentIndex === -1) {
      newItems.push(value)
    } else {
      newItems.splice(currentIndex, 1)
    }
    // console.log(newItems);

    return newItems
  }

  render() {
    const {
      minLengthTestPasses
      // maxLengthTestPasses,
      // repeatedCharactersTestPasses,
      //   containsLowercaseLetterTestPasses,
      //   containsUppercaseLetterTestPasses,
      //   containsNumberTestPasses,
      //   containsSpecialCharacterTestPasses
    } = this.state.passwordTestStatus

    const passwordHelperCriteria = [
      {
        value: minLengthTestPasses,
        description: 'طول کلمه عبور حداقل باید 8 کاراکتر باشد'
      }
      // { value: maxLengthTestPasses, description: "128 characters maximum" },
      // {
      //   value: repeatedCharactersTestPasses,
      //   description: "No more than 3 repeated characters in a row"
      // },
      // {
      //   value: containsLowercaseLetterTestPasses,
      //   description: "کلمه عبور باید حداقل شامل یک حرف کوچک باشد"
      // },
      // {
      //   value: containsUppercaseLetterTestPasses,
      //   description: "کلمه عبور باید حداقل شامل یک حرف بزرگ باشد"
      // },
      // {
      //   value: containsNumberTestPasses,
      //   description: "کلمه عبور باید حداقل شامل یک کاراکتر عددی باشد"
      // },
      // {
      //   value: containsSpecialCharacterTestPasses,
      //   description: "کلمه عبور باید حداقل شامل یک کاراکتر خاص باشد"
      // }
    ]

    const ValidationSchema = Yup.object().shape({
      gender: Yup.string()
        .trim()
        .nullable()
        .required('جنسیت'),
      firstName: Yup.string()
        .trim()
        .nullable()
        .required('نام'),
      lastName: Yup.string()
        .trim()
        .nullable()
        .required('نام خانوادگی'),
      mobile: Yup.string()
        .nullable()
        .matches(/^[0-9]\d{10}$/, {
          message: 'تلفن همراه باید شامل 11 رقم باشد',
          excludeEmptyString: false
        })
        .trim()
        .required('وارد کردن [تلفن همراه] الزامی است'),

      userName: Yup.string()
        .trim()
        .nullable()
        .required('نام کاربری'),

      password: Yup.string()
        // .matches(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*()-_+=/\|?.><])(?=\S+$).{8,}$/, { message: "کلمه عبور باید شامل موارد زیر باشد", excludeEmptyString: false })
        .min(8, 'طول کلمه عبور حداقل باید 8 کاراکتر باشد')
        .trim()
        .required('وارد کردن کلمه عبور الزامی است'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password')], 'تکرار کلمه عبور صحیح نیست')
        .trim()
        .required('تکرار کلمه عبور الزامی است'),

      userType: Yup.number(),
      unionId: Yup.string().when('userType', {
        is: 1,
        then: Yup.string()
          .trim()
          .nullable()
          .required('اتحادیه')
      }),

      email: Yup.string()
        .email('صحیح ایمیل')
        .trim()
        .nullable()
        .required('ایمیل')
    })

    let valuesPermissions = []
    accessTypes.forEach(item => {
      valuesPermissions.push({ accessType: item.value, access: false })
    })

    return (
      <Formik
        initialValues={{
          gender: '',
          firstName: '',
          lastName: '',
          mobile: '',
          userName: '',
          email: '',
          password: '',
          confirmPassword: '',
          unionId: '',
          userType: 1,
          permissions: valuesPermissions
        }}
        onSubmit={(values, { setSubmitting }) => {
          // console.log(JSON.stringify(values));
          this.handleSubmit(values)
          setSubmitting(false)
        }}
        validationSchema={ValidationSchema}>
        {props => {
          const {
            values,
            touched,
            errors,
            // dirty,
            setFieldValue,
            setFieldError,
            setFieldTouched,
            // isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit
            // handleReset,
            // validateForm
          } = props
          return (
            <div>
              <div className="row" style={{ position: 'relative' }}>
                <form onSubmit={handleSubmit}>
                  <Tabs
                    transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}>
                    <Tab eventKey="info" title="مشخصات کاربر">
                      <div className="row">
                        <div className="col-md-11">
                          <div className="form-inline">
                            <div className="col-lg-1 col-sm-12 text-left">
                              <label />
                            </div>
                            <div className="col-lg-3 col-sm-12">
                              <Field
                                component={FormikCheckbox}
                                name="isActive"
                                id="isActive"
                                label={'کاربر فعال است'}
                              />
                            </div>
                            <div className="clearfix form-row" />

                            <div className="col-lg-1 col-sm-12 text-left">
                              <label>نوع کاربر</label>
                            </div>
                            <div
                              className={
                                'col-lg-3 col-sm-12 ' +
                                (touched.userType &&
                                  errors.userType &&
                                  'has-error')
                              }>
                              <RoleSelect
                                name="userType"
                                value={values.userType}
                                defaultValue={values.userType}
                                onChange={val => {
                                  setFieldValue('userType', val)
                                }}
                              />
                              <ErrorPopUp
                                error={errors.userType}
                                touched={touched.userType}
                                type="select"
                              />
                            </div>

                            <div className="col-lg-1 col-sm-12 text-left">
                              <label>اتحادیه</label>
                            </div>
                            <div
                              className={
                                'col-lg-7 col-sm-12 required ' +
                                (touched.unionId &&
                                  errors.unionId &&
                                  'has-error')
                              }>
                              <UnionSelectForAdmin
                                name="unionId"
                                disabled={values.userType !== 1}
                                onChange={val => {
                                  setFieldValue('unionId', val)
                                }}
                              />
                              <ErrorPopUp
                                error={errors.unionId}
                                touched={touched.unionId}
                                type="select"
                              />
                            </div>

                            <div className="clearfix form-row" />

                            <div className="col-lg-1 col-sm-12 text-left">
                              <label>جنسیت</label>
                            </div>
                            <div
                              className={
                                'col-lg-3 col-sm-12 required ' +
                                (touched.gender && errors.gender && 'has-error')
                              }>
                              <GenderSelect
                                name="gender"
                                value={values.gender}
                                defaultValue={values.gender}
                                onChange={val => {
                                  setFieldValue('gender', val)
                                }}
                              />
                              <ErrorPopUp
                                error={errors.gender}
                                touched={touched.gender}
                                type="select"
                              />
                            </div>

                            <div className="col-lg-1 col-sm-12 text-left">
                              <label>نام</label>
                            </div>
                            <div className="col-lg-3 col-sm-12">
                              <Field
                                type="text"
                                name="firstName"
                                className={
                                  getIn(errors, 'firstName') &&
                                  getIn(touched, 'firstName')
                                    ? 'text-input fa has-error'
                                    : 'text-input required fa'
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="firstName"
                              />
                            </div>

                            <div className="col-lg-1 col-sm-12 text-left">
                              <label>نام خانوادگی</label>
                            </div>
                            <div className="col-lg-3 col-sm-12">
                              <Field
                                type="text"
                                name="lastName"
                                className={
                                  getIn(errors, 'lastName') &&
                                  getIn(touched, 'lastName')
                                    ? 'text-input fa has-error'
                                    : 'text-input required fa'
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="lastName"
                              />
                            </div>

                            <div className="clearfix form-row" />

                            <div className="col-lg-1 col-sm-12 text-left">
                              <label>تلفن همراه</label>
                            </div>
                            <div className="col-lg-3 col-sm-12">
                              <NumberFormat
                                isNumericString
                                allowNegative={false}
                                format="###########"
                                name="mobile"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.mobile}
                                className={
                                  getIn(errors, 'mobile') &&
                                  getIn(touched, 'mobile')
                                    ? 'text-input numberFa has-error'
                                    : 'text-input numberFa required'
                                }
                              />
                              <ErrorPopUp
                                error={errors.mobile}
                                touched={touched.mobile}
                                type="fullText"
                              />
                            </div>

                            <div className="col-lg-1 col-sm-12 text-left">
                              <label>ایمیل</label>
                            </div>
                            <div className="col-lg-3 col-sm-12">
                              <Field
                                type="email"
                                name="email"
                                className={
                                  getIn(errors, 'email') &&
                                  getIn(touched, 'email')
                                    ? 'text-input has-error'
                                    : 'text-input required'
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="email"
                              />
                            </div>

                            <div className="col-lg-1 col-sm-12 text-left">
                              <label>نام کاربری</label>
                            </div>
                            <div className="col-lg-3 col-sm-12">
                              <Field
                                type="text"
                                autoComplete="off"
                                name="userName"
                                className={
                                  getIn(errors, 'userName') &&
                                  getIn(touched, 'userName')
                                    ? 'text-input has-error'
                                    : 'text-input required'
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="userName"
                              />
                            </div>
                            <div className="clearfix form-row" />

                            <div className="col-lg-1 col-sm-12 text-left">
                              <label>سطح دسترسی</label>
                            </div>
                            <div className="col-lg-11 col-sm-12">
                              {accessTypes.map((item, index) => (
                                <div>
                                  <Checkbox
                                    label={item.name}
                                    value={
                                      values.permissions &&
                                      values.permissions.filter(
                                        el => el.accessType == item.value
                                      )[0].access
                                    }
                                    onChange={() => {
                                      let items = values.permissions

                                      const currentIndex = values.permissions.findIndex(
                                        el => el.accessType == item.value
                                      )
                                      const newItems = [...items]

                                      let newItem = newItems[currentIndex]
                                      newItem.access = !newItem.access
                                      newItems[currentIndex] = newItem

                                      console.log(newItems)

                                      setFieldValue('permissions', newItems)
                                    }}

                                    // onChange={() => {

                                    //   let value = item.value;
                                    //   let items = values.permissions;

                                    //   const currentIndex = items.indexOf(value);
                                    //   const newItems = [...items];

                                    //   if (currentIndex === -1) {
                                    //     newItems.push(value);
                                    //   } else {
                                    //     newItems.splice(currentIndex, 1);
                                    //   }

                                    //   setFieldValue("permissions", newItems)

                                    // }}
                                  />
                                </div>
                              ))}
                            </div>

                            <div className="clearfix form-row" />
                            <hr />

                            <div className="col-lg-1 col-sm-12 text-left">
                              <label>کلمه عبور</label>
                            </div>
                            <div className="col-lg-5 col-sm-12">
                              <Field
                                type="password"
                                autoComplete="off"
                                id="password"
                                name="password"
                                value={this.state.passwordValue}
                                onChange={e =>
                                  this.onPasswordChange(e, setFieldValue)
                                }
                                className={
                                  getIn(errors, 'password') &&
                                  getIn(touched, 'password')
                                    ? 'text-input has-error'
                                    : 'text-input required'
                                }
                              />
                              <ErrorPopUp
                                error={errors.password}
                                touched={touched.password}
                                type="fullText"
                              />
                            </div>

                            <div className="col-lg-1 col-sm-12 text-left">
                              <label>تکرار کلمه عبور</label>
                            </div>
                            <div className="col-lg-5 col-sm-12">
                              <Field
                                type="password"
                                name="confirmPassword"
                                className={
                                  getIn(errors, 'confirmPassword') &&
                                  getIn(touched, 'confirmPassword')
                                    ? 'text-input has-error'
                                    : 'text-input required'
                                }
                              />
                              <ErrorPopUp
                                error={errors.confirmPassword}
                                touched={touched.confirmPassword}
                                type="fullText"
                              />
                            </div>
                            <div className="clearfix form-row" />
                            <div className="col-lg-1 col-sm-12 text-left">
                              <label />
                            </div>
                            <div className="col-lg-5 col-sm-12">
                              <PasswordHelper
                                criteria={passwordHelperCriteria}
                              />
                            </div>

                            <div className="col-md-12 ">
                              <button
                                type="submit"
                                className="icon button submit-btn pull-left"
                                onClick={() => console.log(errors)}>
                                ذخیره
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </form>
              </div>
              {this.state.loading ? <Loading /> : ''}
            </div>
          )
        }}
      </Formik>
    )
  }
}
export default NewAppUser
